import { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import DashboardLayout from 'prefabsComponents/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'prefabsComponents/Navbars/DashboardNavbar';
import Footer from 'prefabsComponents/Footer';
import DataTable from 'prefabsComponents/Tables/DataTable';
import useFetch from 'hooks/useFetch';
import DefaultCell from 'layouts/pages/orders/order-list/components/DefaultCell';
import DataTableLoader from 'components/DataTableLoader';
import DataTableHeaderOptions from 'components/DataTableHeaderOptions';
import DataTableDocumentActions from 'components/DataTableDocumentActions';
import EditIcon from '@mui/icons-material/Edit';
import CreateNewModal from './CreateNewModal';

const Providers = () => {
    const { data, isLoading, refetch } = useFetch('/api/maintenance/providers/');
    const [dataTableData, setDataTableData] = useState({ columns: [], rows: [] });
    const [selectedProvider, setSelectedProvider] = useState(null);

    useEffect(() => {
        if(data){
            const renderCell = ({ value }) => <DefaultCell value={value} />;

            const columns = [
                { Header: 'Id', accessor: 'id_proveedor', Cell: renderCell },
                { Header: 'Cliente', accessor: 'cliente', Cell: renderCell },
                { Header: 'Proveedor', accessor: 'nombre', Cell: renderCell },
                { Header: 'Dirección', accessor: 'direccion', Cell: renderCell },
                { Header: 'Ciudad', accessor: 'ciudad', Cell: renderCell },
                { Header: 'Estado', accessor: 'estado', Cell: renderCell },
                { Header: 'Zip Code', accessor: 'zipcode', Cell: renderCell },
                { Header: 'Acciones', accessor: 'acciones', Cell: renderCell },
            ];

            const rows = data.map((provider) => ({
                id_proveedor: provider.id_proveedor,
                cliente: provider.cliente,
                nombre: provider.nombre,
                direccion: provider.direccion,
                ciudad: provider.ciudad,
                estado: provider.estado,
                zipcode: provider.zipcode,
                acciones: (
                    <DataTableDocumentActions
                        actions={[{
                            Icon: EditIcon,
                            onClick: () => handleEdit(provider),
                            color: 'primary'
                        }]}
                    />
                )
            }));

            setDataTableData({ columns, rows });
        }
    }, [data]);

    const handleEdit = (provider) => {
        setSelectedProvider(provider);
    };

    return (
        <DashboardLayout>           
            <DashboardNavbar />
            <DataTableHeaderOptions
                createNewTitle='Nuevo Proveedor'
                dataTableData={dataTableData}
                setSelectedDocument={setSelectedProvider}
                selectedDocument={selectedProvider}
                hasFilters={false}
                getData={refetch}
                isLoading={isLoading}
                CreateNewModal={CreateNewModal}
            />
            <Card>
                {isLoading ? (
                    <DataTableLoader />
                ) : (
                    <DataTable
                        table={dataTableData}
                        entriesPerPage={true}
                        canSearch={true}
                        showTotalEntries={true}
                    />  
                )}
            </Card>
            <Footer />
        </DashboardLayout>
    );
}

export default Providers;
